/**
 * Forms Module
 * Form validation and enhancement
 */

const Forms = {
    init() {
        this.validateForms();
        this.enhanceInputs();
    },

    validateForms() {
        const forms = document.querySelectorAll('form[data-validate]');
        
        forms.forEach(form => {
            form.addEventListener('submit', (e) => {
                if (!this.isValid(form)) {
                    e.preventDefault();
                    this.showErrors(form);
                }
            });

            // Real-time validation
            const inputs = form.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
                input.addEventListener('blur', () => {
                    this.validateField(input);
                });
            });
        });
    },

    isValid(form) {
        const requiredFields = form.querySelectorAll('[required]');
        let isValid = true;

        requiredFields.forEach(field => {
            if (!this.validateField(field)) {
                isValid = false;
            }
        });

        return isValid;
    },

    validateField(field) {
        const value = field.value.trim();
        let isValid = true;
        let errorMessage = '';

        // Required check
        if (field.required && !value) {
            isValid = false;
            errorMessage = 'Dieses Feld ist erforderlich';
        }

        // Email validation
        if (field.type === 'email' && value) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(value)) {
                isValid = false;
                errorMessage = 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
            }
        }

        // Pattern validation
        if (field.pattern && value) {
            const pattern = new RegExp(field.pattern);
            if (!pattern.test(value)) {
                isValid = false;
                errorMessage = field.dataset.errorMessage || 'Ungültiges Format';
            }
        }

        // Update UI
        this.updateFieldUI(field, isValid, errorMessage);

        return isValid;
    },

    updateFieldUI(field, isValid, errorMessage) {
        const formGroup = field.closest('.form-group');
        if (!formGroup) return;

        const existingError = formGroup.querySelector('.form-error');
        
        if (existingError) {
            existingError.remove();
        }

        if (!isValid) {
            field.classList.add('is-invalid');
            field.classList.remove('is-valid');
            
            const error = document.createElement('span');
            error.className = 'form-error';
            error.textContent = errorMessage;
            formGroup.appendChild(error);
        } else {
            field.classList.remove('is-invalid');
            field.classList.add('is-valid');
        }
    },

    showErrors(form) {
        const firstError = form.querySelector('.is-invalid');
        if (firstError) {
            firstError.focus();
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    },

    enhanceInputs() {
        // Add floating labels
        const floatingInputs = document.querySelectorAll('.form-input--floating');
        floatingInputs.forEach(input => {
            input.addEventListener('focus', () => {
                input.parentElement.classList.add('is-focused');
            });
            input.addEventListener('blur', () => {
                input.parentElement.classList.remove('is-focused');
                if (input.value) {
                    input.parentElement.classList.add('has-value');
                } else {
                    input.parentElement.classList.remove('has-value');
                }
            });
        });
    }
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    Forms.init();
});

export default Forms;
